export const readFileAsBase64 = async (file: File) => {
    return new Promise<string>((resolve) => {
        const reader = new FileReader();

        reader.addEventListener(
            "load",
            () => {
                // convert image file to base64 string
                resolve(reader.result as string);
            },
            false,
        );

        reader.readAsDataURL(file);
    });
};

export const saveToFile = (fileName: string, fileType: string, text: string) => {
    var blob = new Blob([text], { type: fileType });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
};

export const getFileExt = (fileName: string) => {
    const index = fileName.lastIndexOf(".");
    return index >= 0 ? fileName.substring(index + 1) : "";
};
